export default "__VITE_ASSET__DmvxJn_6__"